import {FC} from 'react'

import {Text, TextVariant} from '@/components/common/content/Text'
import {theme} from '@/theme/theme'
import {MOBILE_SCREENSIZE, TABLET_SCREENSIZE} from '@/utils/styles/breakpoints'

type CardListLayoutProps = {
  title?: string
  description?: string
  isCentered?: boolean
  titleMaxWidth?: string
}

export const CardListLayout: FC<React.PropsWithChildren<CardListLayoutProps>> = ({
  title,
  description,
  isCentered = true,
  titleMaxWidth = '720px',
  children,
}) => {
  return (
    <>
      {title && (
        <div className="wrapper">
          <Text variant={TextVariant.h2} align="center">
            {title}
          </Text>
        </div>
      )}
      {description && (
        <div className="wrapper description">
          <Text variant={TextVariant.text20} color={theme.palette.text.light} align="center">
            {description}
          </Text>
        </div>
      )}
      <div className="content">{children}</div>

      <style jsx>{`
        .wrapper {
          max-width: ${titleMaxWidth};
          margin: 0 auto;
        }
        .description {
          margin-top: ${theme.spacing[3]};
        }
        .content {
          display: flex;
          flex-wrap: wrap;
          margin: ${theme.spacing[7]} -${theme.spacing[3]} -${theme.spacing[3]};
        }
        @media ${TABLET_SCREENSIZE} {
          .content {
            margin: ${theme.spacing[7]} -${theme.spacing[2.5]} -${theme.spacing[2.5]};
            justify-content: ${isCentered ? 'center' : 'flex-start'};
          }
        }
        @media ${MOBILE_SCREENSIZE} {
          .content {
            margin: ${theme.spacing[6]} 0 0;
          }
        }
      `}</style>
    </>
  )
}
